import { providerArray, ProviderKey } from "@smart/bridge-providers-dom";
import { StatusOverlay } from "@smart/itops-sb-design-system-dom";

type ProvidersProps = {
  select: (provider: ProviderKey) => void;
  errorCode?: string;
};

const Providers = ({ select, errorCode }: ProvidersProps) => (
  <>
    {errorCode && <StatusOverlay status="error" errorCode={errorCode} />}
    <p>
      To get started, <strong>select your practice management provider</strong>:
    </p>
    <div className="flex flex-col gap-large mt-[3rem]">
      {providerArray.map(([provider, { logo, label }]) => (
        <button
          key={provider}
          type="button"
          onClick={() => select(provider)}
          className="flex items-center gap-medium mx-auto"
        >
          <img className="h-[2.5rem]" src={logo} alt={label} />
          {label}
        </button>
      ))}
    </div>
  </>
);

export { Providers, ProvidersProps };
